export default {"src":"/_next/static/media/qa_refine.be7163e2.svg","height":2150,"width":1579,"blurWidth":0,"blurHeight":0};